import React from 'react'
import '../../fonts/fonts.css'
import SideBar from '../SideBar/index'
import Cart from '../Cart/index'
import { Bg, MainLayout, ContentLayout } from './styledComponents'

const CartPage = () => {
  return (
    <Bg>
      <SideBar />
      <MainLayout>
        <ContentLayout>
          <Cart />
        </ContentLayout>
      </MainLayout>
    </Bg>
  )
}

export default CartPage
